import React from 'react';
import styled from 'styled-components';
import {FormattedMessage} from 'react-intl';
import messages from './messages';
import {Div} from 'components/primitives/body';


class InvalidToken extends React.Component {

    render() {
        return (
            <Div>
                <TextWrapper>
                    <p>
                        <FormattedMessage {...messages.description} values={{
                            link: <a href={'/login/recover'} rel='noreferrer noopener' target='_blank'>this page.</a>
                        }}/>
                    </p>
                </TextWrapper>
            </Div>
        );
    }
}

const TextWrapper = styled.div`
  margin: 20px 0;
`;

export default InvalidToken;
